(function () {
  const STORAGE_KEY = 'heathen_wishlist_v1';

  function readHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const data = raw ? JSON.parse(raw) : [];
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function writeHandles(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    document.dispatchEvent(new CustomEvent('heathen:wishlist-changed', { detail: { count: handles.length } }));
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.heathenMoneyFormat) {
      return Shopify.formatMoney(cents, window.heathenMoneyFormat);
    }
    var n = (Number(cents) || 0) / 100;
    return n.toFixed(2);
  }

  function imageSrc(url) {
    if (!url) return '';
    return url.indexOf('?') >= 0 ? url + '&width=480' : url + '?width=480';
  }

  const api = {
    list: readHandles,
    add: function (handle) {
      var h = readHandles();
      if (h.indexOf(handle) === -1) {
        h.push(handle);
        writeHandles(h);
      }
    },
    remove: function (handle) {
      writeHandles(readHandles().filter(function (x) {
        return x !== handle;
      }));
    },
    toggle: function (handle) {
      var h = readHandles();
      var i = h.indexOf(handle);
      if (i >= 0) {
        h.splice(i, 1);
        writeHandles(h);
        return false;
      }
      h.push(handle);
      writeHandles(h);
      return true;
    },
    has: function (handle) {
      return readHandles().indexOf(handle) >= 0;
    },

    updateHeaderBadge: function () {
      var el = document.getElementById('header-wishlist-count');
      if (!el) return;
      var n = readHandles().length;
      el.textContent = String(n);
      el.hidden = n === 0;
      el.setAttribute('aria-hidden', n === 0 ? 'true' : 'false');
    },

    bindToggleButtons: function () {
      document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;

        var syncAll = function () {
          var on = api.has(handle);
          document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach(function (b) {
            if (b.getAttribute('data-product-handle') !== handle) return;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            var addL = b.getAttribute('data-add-label') || 'Add to wishlist';
            var remL = b.getAttribute('data-remove-label') || 'Remove from wishlist';
            var textEl = b.querySelector('.wishlist-toggle-text');
            if (textEl) textEl.textContent = on ? remL : addL;
            if (b.hasAttribute('aria-label')) {
              b.setAttribute('aria-label', on ? remL : addL);
            }
          });
        };

        syncAll();
        btn.addEventListener('click', function () {
          api.toggle(handle);
          syncAll();
        });
      });
    },

    cardEl: function (p, handle) {
      var article = document.createElement('article');
      article.className = 'heathen-wishlist-card';
      var imgUrl = imageSrc(p.featured_image || '');
      var price = formatMoney(p.price);
      var title = (p.title || '').replace(/</g, '&lt;');
      var url = p.url || '/products/' + encodeURIComponent(handle);

      article.innerHTML =
        '<a class="heathen-wishlist-card__media" href="' +
        url +
        '">' +
        (imgUrl
          ? '<img src="' + imgUrl + '" alt="" width="480" height="480" loading="lazy">'
          : '<span class="heathen-wishlist-card__placeholder"></span>') +
        '</a>' +
        '<div class="heathen-wishlist-card__info">' +
        '<a class="heathen-wishlist-card__title" href="' +
        url +
        '">' +
        title +
        '</a>' +
        '<p class="heathen-wishlist-card__price">' +
        price +
        '</p>' +
        '<button type="button" class="button button--secondary heathen-wishlist-remove" data-product-handle="' +
        handle +
        '">' +
        (window.heathenWishlistRemoveLabel || 'Remove') +
        '</button>' +
        '</div>';

      return article;
    },

    renderPage: function () {
      var root = document.getElementById('heathen-wishlist-root');
      var empty = document.getElementById('heathen-wishlist-empty');
      if (!root) return;

      var handles = readHandles();
      if (handles.length === 0) {
        root.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;
      root.innerHTML = '<p class="heathen-wishlist-loading">' + (window.heathenWishlistLoadingLabel || 'Loading…') + '</p>';

      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (res) {
              if (!res.ok) return null;
              return res.json().then(function (p) {
                return { handle: handle, p: p };
              });
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (rows) {
        root.innerHTML = '';
        var frag = document.createDocumentFragment();
        rows.forEach(function (row) {
          if (!row || !row.p) return;
          frag.appendChild(api.cardEl(row.p, row.handle));
        });
        if (frag.childNodes.length === 0) {
          if (empty) empty.hidden = false;
        } else {
          root.appendChild(frag);
        }
      });
    },
  };

  window.HeathenWishlist = api;

  document.addEventListener('DOMContentLoaded', function () {
    api.bindToggleButtons();
    api.updateHeaderBadge();
    api.renderPage();

    document.addEventListener('heathen:wishlist-changed', function () {
      api.updateHeaderBadge();
      api.renderPage();
    });

    document.body.addEventListener('click', function (e) {
      var rm = e.target.closest('.heathen-wishlist-remove');
      if (rm) {
        var h = rm.getAttribute('data-product-handle');
        if (h) {
          api.remove(h);
          api.renderPage();
          api.updateHeaderBadge();
        }
      }
    });
  });
})();
